<script setup lang="ts">
import { useGetHeader } from './composables';

const { isDesktop } = useGetDevice();

const pageStore = usePageStore();

const customData = useGetHeader(pageStore.headerType);
</script>

<template>
  <header id="main-header" class="relative z-10 w-full">
    <LazyDesktopHeader
      v-if="isDesktop"
      :data="pageStore.treeNavigation"
      :color="pageStore.headerColor"
      :custom-data
    />
    <LazyMobileHeader
      v-else
      :data="pageStore.treeNavigation"
      :custom-data
      :color="pageStore.headerColor"
    />
  </header>
</template>
